// extracted by mini-css-extract-plugin
module.exports = {"bb-featured-event-image":"bb-featured-event-image__b6akr"};